<template>
  <div class="thal-page">
    <nav2 :title="$t('recordsBet.t_1')"></nav2>
    <div class="bet-record">

        <div class="item-list" @click.stop="_next_list(item.id,item.expect)" v-for="(item,index) in list" :key="index">
          <div class="item-periods">{{ item.record_time }}</div>
          <div class="item-list-title">{{$t('recordsBet.t_3')}}：<span>{{ item.transaction_id }}</span></div>
          <div class="item-list-title">{{$t('recordsBet.t_6')}}：<span>{{ item.lottery_name }}</span></div>
          <div class="item-list-title">{{$t('recordsBet.t_2')}}：<span>{{ item.bet_number }}</span></div>
          <div class="item-list-title">{{$t('recordsBet.t_4')}}：<span>{{ item.bet }}</span></div>
          <div class="item-list-title">{{$t('recordsBet.t_5')}}：<span>{{ item.profit }}</span></div>
        </div>
      <div class="next-page" v-if="isRoll==false"><div @click.stop="_infinite">Next</div></div>

    </div>
  </div>

</template>
<script>
import nav2 from '../THAL/navs.vue'
export default {
  name: "recordBet",
  components:{nav2},
  data(){
    return{
      list:[],
      isRoll:true,
      curPage:0,
      last_Page:0,
    }
  },
  created() {
    let _self=this;
    _self._lottery_order();
  },
  methods:{
    _lottery_order:function (){
      let _self=this;
      let page = parseFloat(_self.curPage) + 1;
      _self.curPage = page;
      if (_self.last_Page == 0) {
        _self.last_Page = page;
      }
      this._PublicFun.getData('2','get', 'order/lottery?page='+page, {}, function (result) {
        if(result.data['status_code']==200){
          let meta = result.data['meta'];
          let current_page = meta.current_page;
          if (current_page == 1) {
            _self.list = [];
          }
          if (result.data['data'].length > 0) {
            for (let i = 0; i < result.data['data'].length; i++) {
              result.data['data'][i].show=0;
              _self.list.push(result.data['data'][i]);
            }
          }
          if (meta.last_page <= page) {
            _self.isRoll = true;
          } else {
            _self.last_Page = meta.last_page;
            _self.isRoll = false;
          }
        }

      })
    },
    _infinite() {
      if (this.isRoll == false) {
        this._lottery_order();
        this.isRoll = true;

      }
    },
    _next_list:function (id,no){
      let _self=this;
      _self.$router.push({path:'/THAL/record/list?id='+id+'&no='+no})
    }
  }
}
</script>
<style scoped>
.bet-record{
  display: block;
  width: 100%;
  max-width: 750px;
  margin: 55px auto 0;
}
.item-list{
  display: block;
  width: 94%;
  margin: 10px auto;
  padding: 5px 0;
  background-color: #242424;
  border-radius: 5px;
  cursor: pointer;
}
.item-periods{
  display: block;
  width: 96%;
  margin: 0 auto;
  padding: 10px 0;
  color: #F4D788;
}
.item-list-title{
  display: block;
  width: 96%;
  margin: 0 auto;
  padding:2px 0;
  clear: both;
  color: #FFFFFF;
  font-size: 12px;
}
.item-list-title span{
  float: right;
  font-size: 14px;
}
.next-page{
  display: flex;
  width: 100%;
  margin: 0 auto;
  padding: 0;
  justify-content: flex-end;
}
.next-page div{
  padding: 8px 25px;
  background-color: #FFFFFF;
  color: #000000;
  border-radius: 5px;
  cursor: pointer;

}


</style>



// WEBPACK FOOTER //
// src/components/THAL/recordBet.vue